<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <DefectParetoChartForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DefectParetoChartForm from '@/components/organisms/report/form/DefectParetoChartForm'

export default {
  name: 'DefectParetoChartPage',
  components: { DefectParetoChartForm },
}
</script>
